/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/

import React, {useState, useEffect} from "react";
import PropTypes from "prop-types";

import Head from "next/head";

import SubscribeNewsletterPopUp from "./SubscribeNewsletterPopUp";

import {
  WealthyValidations,
  WealthyEnv,
  triggerToast,
  handleApiError
} from "helpers";
import {requestSubscription} from "api";

const defaultProps = {
  subscriptionApi :null
};

const propTypes = {
  closePopUp: PropTypes.func.isRequired,
  subscribeText:PropTypes.string,
  subscriptionApi:PropTypes.any,
};

const SubscribeNewsletterPopUpContainer = ({
  closePopUp,
  subscribeText,
  subscriptionApi
}) => {
  const [email, setEmail] = useState("");
  const [token, setToken] = useState(null);
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    initCaptcha();
  }, []);

  const subscribeInputHandler = (e) => {
    setEmail(e.currentTarget.value);
  };

  const submitSubscribe = async (e) => {
    e.preventDefault();

    const emailCheck = WealthyValidations.validateFormField.email(email);
    const api = subscriptionApi?.length > 0 ? subscriptionApi :requestSubscription
    if (!emailCheck) {
      return triggerToast("Please enter a valid email ID");
    } else {
      try {
        setIsLoading(true)
        const res = await api({email, token});
        if (res) {
          triggerToast("Thanks for subscribing. Please check your mail for confirmation", "success");
        }
        setTimeout(()=> {
          setIsLoading(false);
        },1000)
        if (window?.analytics) {
          window?.analytics.track("Subscription requested", {
            category: "Money Order",
            label: "Subscription"
          });
        } else {
          console.log("analytics not set, analytics not available");
        }
        closePopUp();
      } catch (error) {
        handleApiError(error);
        setTimeout(()=> {
          setIsLoading(false);
        },1000)
      }
    }
  };

  const initCaptcha = () => {
    window?.grecaptcha?.ready(function () {
     window?.grecaptcha?.execute(`${WealthyEnv.RECAPTCHA_TOKEN}`, {action: "homepage"})
        .then(function (token) {
          setToken(token);
        });
    });
  };

  return (
    <>
      <Head>
        <script src={WealthyEnv.RECAPTCHA_TOKEN_URL} />
      </Head>
      <SubscribeNewsletterPopUp
        closePopUp={closePopUp}
        email={email}
        submitSubscribe={submitSubscribe}
        subscribeInputHandler={subscribeInputHandler}
        isLoading={isLoading}
        subscribeText={subscribeText}
      />
    </>
  );
};

SubscribeNewsletterPopUpContainer.propTypes = propTypes;
SubscribeNewsletterPopUpContainer.defaultProps = defaultProps;

export default SubscribeNewsletterPopUpContainer;
